<template>
  <div :class="['gate-stage', customClass]">
    <div class="gate-stage-title">
      <h2>{{title}} <span v-if="required_step" style="color: red">*</span> </h2>
      <div v-if="switchable" class="gate-stage-switcher">
        <Switcher :id="'gate-link-switcher'"
                  :flag="initialStatus"
                  @flage="changeState($event)"
                  :disabled="false"
        />
      </div>
    </div>
    <div class="gate-stage-main">
      <slot name="main"/>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import Switcher from "../Switcher/Switcher.vue";
export default Vue.extend({
  components: {Switcher},
  data() {
    return {
      status: false
    }
  },
  props: {
    title: {
      type: String
    },
    required_step: {
      type: Boolean,
      default: false
    },
    customClass: {
      type: String,
      default: undefined
    },
    switchable: {
      type: Boolean,
      default: false
    },
    initialStatus: {
      type: Boolean
    }
  },
  methods: {
    changeState(event) {
      console.log(event.status)
      this.status = event.status
      this.$emit('change-state', event.status)
    }
  },
  mounted () {
    this.status = this.initialStatus
  }
})
</script>
<style lang="scss" scoped>;
.gate-stage {
  //// !!! временно, отступы должны ставиться с родительского компонента
  //margin-right: 20px;
  &-title {
    height: 44px;
    width: 100%;
    background-color: $color-blue-light;
    padding: 10px 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    h2 {
      font-family: Montserrat, sans-serif;
      font-size: 16px;
      font-style: normal;
      font-weight: 600;
      line-height: 24px;
      color: $color-main-text;
    }
  }
  &-main {
    padding: 16px 0;
  }
}
</style>